<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CustomersApi from "@/services/customers-api";
import MessagesApi from "@/services/messages-api";
import Swal from "sweetalert2";
//import { watch } from "vue";

export default {
  page: {
    title: "Messages",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },

  data() {
    return {
      subject: "",
      content: "",
      selectedCustomers: null,
      flteredCustomer: null,
      customersList: [],
      messagesList:[],
      isClaimReportingEnabled: false,
      pagemodelMain: {currentPage : 1, perPage : 10, totalRows: 0},
      startDate:null,
      endDate:null,
      role: null,
      isTableLoading: false,
      sendToAllCustomers: false,
      messageFields: [
                {
          key: "viewedTimeStamp",
          label: "",
          thClass: "text-left",
          tdClass: "text-left", thStyle: "width:30px;"
        },
        {
          key: "timestamp",
          label: "Date",
          thClass: "text-left",
          tdClass: "text-left", thStyle: "width:200px;"
        },
         {
          key: "subject",
          label: "Objet",
          thClass: "text-left",
          tdClass: "text-left "
        },
        {
          key: "customerName",
          label: "Client",
          thClass: "text-left",
          tdClass: "text-left"
        },
       
        {
          key: "actions",
          label: "",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],

      selectedMessage: null,
      showMessageModal: false,

    };

  },

  watch: {
    startDate: function() {
      this.findAllMessages();
    },
    endDate: function() {
      this.findAllMessages();
    }
  },

  mounted() {
    this.role = sessionStorage.getItem("userr")
    this.getCustomers()
    this.findAllMessages()
  },

  computed: {
    messageFieldsFiltered() {
      let fields = this.messageFields;

      if (this.role == 0) {
        fields = fields.filter(f => f.key !== 'customerName');
      }

      return fields;
    }
  },

  methods: {

    openMessage(message) {
      this.selectedMessage = message;
      this.showMessageModal = true;
      this.markMessageViewed(message.id);
    },

    closeMessageModal() {
      this.showMessageModal = false;
      this.selectedMessage = null;
    },

    deleteMessage(item) {

    Swal.fire({
          title: "Confirmation",
          text: "Voulez-vous vraiment supprimer ce message ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#6c757d",
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer",

    }).then(result => {
      if (result.value) {

        MessagesApi.deleteMessage(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.startDate,this.endDate,this.flteredCustomer ? this.flteredCustomer.id : null, item.id)
          .then(
            response => {
              this.messagesList=response.list;
              this.pagemodelMain.totalRows = response.total;
              this.pagemodelMain.currentPage = response.page;
              this.pagemodelMain.perPage = response.pageSize;
              this.pagemodelMain.pageSize = response.pageSize;
            }
          ).finally(() => {
            this.isTableLoading = false;
          });

      }
    });
  },

    getCustomers(){
      CustomersApi.getCustomers().then(
          response => {
          this.customersList=response;
          }
      )
    },

    markMessageViewed(messageId) {
      this.isTableLoading = true;

      MessagesApi.markMessageViewed(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.startDate,this.endDate,this.flteredCustomer ? this.flteredCustomer.id : null, messageId).then(
        response => {
          this.messagesList=response.list;
          this.pagemodelMain.totalRows = response.total;
          this.pagemodelMain.currentPage = response.page;
          this.pagemodelMain.perPage = response.pageSize;
          this.pagemodelMain.pageSize = response.pageSize;
        }
      ).finally(() => {
        this.isTableLoading = false;
      });
    },

    findAllMessages() {
      this.isTableLoading = true;
      MessagesApi.getMessage(this.pagemodelMain.currentPage, this.pagemodelMain.perPage,this.startDate,this.endDate,this.flteredCustomer ? this.flteredCustomer.id : null).then(
        response => {
          this.messagesList=response.list;
          this.pagemodelMain.totalRows = response.total;
          this.pagemodelMain.currentPage = response.page;
          this.pagemodelMain.perPage = response.pageSize;
          this.pagemodelMain.pageSize = response.pageSize;
        }
      ).finally(() => {
        this.isTableLoading = false;
      });
    },

    createMessage() {
      const swalText = this.sendToAllCustomers
        ? "Ce message sera envoyé à <strong style='text-transform:uppercase'>tous les clients inscrits</strong> sur la plateforme. Continuer ?"
        : "Ce message sera envoyé aux <strong style='text-transform:uppercase'>client(s) sélectionné(s)</strong>. Continuer ?";

      Swal.fire({
        html: swalText,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Envoyer",
        cancelButtonText: "Annuler",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        reverseButtons: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.sendMessage();
        }
      });
    },

    sendMessage() {
      this.isTableLoading = true;

      const customerIds = this.sendToAllCustomers ? null :
      this.selectedCustomers?.length ? this.selectedCustomers.map(c => c.id) : null;

      const message = {
        subject: this.subject,
        content: this.content,
        customerIds: customerIds
      };

      MessagesApi.createMessage(message)
        .then((response) => {
          this.messagesList = response.list;
          this.pagemodelMain.totalRows = response.total;
          this.pagemodelMain.currentPage = response.page;
          this.pagemodelMain.perPage = response.pageSize;
          this.pagemodelMain.pageSize = response.pageSize;

          this.subject = "";
          this.content = "";
          this.selectedCustomers = [];
          this.sendToAllCustomers = false;
        })
        .catch(() => {
          this.$snotify.error("Erreur lors de l'envoi du message");
        })
        .finally(() => {
          this.isTableLoading = false;
        });
    }

  },
};
</script>

<template>
  <Layout>

    <div>
      <div class="row p-sm-4" v-if="role && role == 2">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <h3 class="card-title text-primary" style="font-size:1.5em;">
                    Nouveau Message
                  </h3>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-2 col-xs-0"></div>

                <div class="col-lg-6 pt-4 mr-4 col-11 col-md-8">
                  <div class="col-12 position-relative col-sm-11 col-md-12">
                    <b-form-group label-for="" class="mt-2 mb-0">
                      <label>
                        <span style="color: black">Objet</span><span class="text-danger"> *</span>
                      </label>
                      <b-form-input v-model="subject" :maxlength="50" class="form-control font-size-14 mr-4" placeholder="Objet"/>
                    </b-form-group>

                    <b-form-group class="mt-4 mb-0">
                      <b-form-checkbox v-model="sendToAllCustomers">
                        Envoyer ce message à tous les clients
                      </b-form-checkbox>
                    </b-form-group>

                    <b-form-group label-for="" class="mt-2 mb-0">
                      <label>
                        <span style="color: black">Client</span>
                      </label>
                      <div class="col-12 text-right">
                        <v-select
                          class="" style="font-size:1.2em;"
                          :options="customersList"
                          placeholder="Clients"
                          label="name"
                          v-model="selectedCustomers"
                          multiple
                          :disabled="sendToAllCustomers"
                        >
                          <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                        </v-select>
                      </div>
                    </b-form-group>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-2 col-xs-0"></div>
                <div class="col-lg-8 col-md-10 col-xs-12">
                  <b-form-group label-for="" class="mt-4 mb-0">
                    <label>
                      <span style="color: black">Message</span><span class="text-danger"> *</span>
                    </label>
                    <textarea
                      v-model="content"
                      class="form-control font-size-14"
                      :maxlength="3000"
                      rows="10"
                      placeholder="Ajouter votre réclamation ou suggestion"
                    ></textarea>
                  </b-form-group>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-md-7 col-sm-9 col-xs-0"></div>
                <div class="col-sm-3 col-xs-12">
                  <b-button variant="primary" class="w-100 font-weight-bold" @click="createMessage" :disabled="!sendToAllCustomers && (!selectedCustomers || selectedCustomers.length===0) || !subject || !content">
                    <i class="fas fa-paper-plane align-middle mr-2 ml-2"></i> Envoyer
                  </b-button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      
      <div class="row pt-4 p-sm-4">
        <div class="col-lg-12">
          <div class="card border">
            <div class="card-body">

              <div class="row">
                <div class="col-md-8 col-sm-12">
                  <h3 class="card-title text-primary" style="font-size:1.5em;">
                    Liste des Messages
                  </h3>
                </div>
              </div>

              <!-- Filters -->
              <div class="row mt-4">
                <div class="col-md-4 col-12  pr-md-2 pr-0" v-if="role && role == 2">
                  <label>Client</label>
                  <v-select
                  class="style-vselect-big" style="font-size:16px;"
                    placeholder="Clients"
                    :options="customersList"
                    label="name"
                    v-model="flteredCustomer"
                    @input="findAllMessages"
                  />
                </div>

                <div class="col-md-4 col-12 pl-md-2 pl-0 pr-md-2 pr-0">
                  <label>Date début</label>
                  <b-form-datepicker
                    v-model="startDate"
                    locale="fr"
                    label-no-date-selected="Date Début"
                    dark
                    reset-button
                    close-button
                    label-reset-button="Réinitialiser"
                    label-close-button="Fermer"
                    dropright
                    hide-header
                  />
                </div>

                <div class="col-md-4 col-12  pl-md-2 pl-0 ">
                  <label>Date fin</label>
                  <b-form-datepicker
                    v-model="endDate"
                    locale="fr"
                    label-no-date-selected="Date Fin"
                    dark
                    reset-button
                    close-button
                    label-reset-button="Réinitialiser"
                    label-close-button="Fermer"
                    dropright                         
                    hide-header
                  />
                </div>
              </div>

              
              <!-- Table -->
              <div class="row pt-4">
                <div class="col-12">
                  <b-table
                    :busy="isTableLoading"
                    :items="messagesList"
                    :fields="messageFieldsFiltered"
                    striped
                    hover
                  >
                    <template #table-busy>
                      <div class="text-center my-2">
                        <b-spinner variant="primary" />
                      </div>
                    </template>

                    <template #cell(content)="{ value }">
                      <span class="truncate-title">{{ value }}</span>
                    </template>

                    <template #cell(viewedTimeStamp)="{ value }">

                        <i class=" text-primary font-size-20 " :class="value ? 'far fa-envelope-open text-dark' : 'fas fa-envelope text-warning' " />
                        <!--b-badge :variant="value ? 'success' : 'danger'">
                          {{ value ? 'Lu' : 'Non lu' }}
                        </b-badge-->
                    </template>

                    <template #cell(subject)="{ item }">
                      <span class="font-size-14" :class="item.viewedTimeStamp ? '' : 'font-weight-bold'">{{ item.subject }}</span>
                    </template>

                    <template #cell(timestamp)="{ item }">
                      <span class="font-size-14" :class="item.viewedTimeStamp ? '' : 'font-weight-bold'">{{ item.timestamp }}</span>
                    </template>

                    <template #cell(customerName)="{ item }">
                      <span class="font-size-14" :class="item.viewedTimeStamp ? '' : 'font-weight-bold'">{{ item.customerName }}</span>
                    </template>


                    <template #cell(actions)="{ item }">
                      <div class="d-flex justify-content-center align-items-center font-size-14">

                        <span
                          class="text-success mr-3 border border-success px-2 py-1 rounded-pill"
                          style="cursor: pointer;"
                          @click="openMessage(item)"
                        >
                          Voir
                        </span>

                        <i  v-if="role && role == 2"
                          class="mdi mdi-trash-can font-size-22 text-danger"
                          style="cursor: pointer;"
                          title="Supprimer"
                          @click="deleteMessage(item)"
                        ></i>
                      </div>
                    </template>

                  </b-table>

                  <div v-if="!isTableLoading && !messagesList.length"
                      class="text-center text-danger mt-4">
                    Aucun message trouvé
                  </div>
                </div>
              </div>


                <!-- Pagination -->
                <div class="row pt-3 mb-sm-4">
                    <div class="col-sm-8">
                        <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                            <b-form-select @input="findAllMessages()"  v-model="pagemodelMain.perPage" size="sm" style="width: 60px" :options="[10,15,50,100]"></b-form-select>
                            <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMain.totalRows}} lignes</span></div>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="dataTables_paginate paging_simple_numbers float-right">
                            <ul class="pagination pagination-rounded mb-0">
                            <b-pagination v-model="pagemodelMain.currentPage" :disabled="isTableLoading" :per-page="pagemodelMain.pageSize" :total-rows="pagemodelMain.totalRows" @input="findAllMessages()" ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div> 
                <!-- Fin Pagination  -->

            </div>
          </div>
        </div>
      </div>




    <b-modal
      v-model="showMessageModal"
      :title="'Objet : ' + (selectedMessage && selectedMessage.subject ? selectedMessage.subject : '')"
      size="lg"
      hide-footer
      centered
    >
      <div v-if="selectedMessage">

       

        <div class="row mb-3">
          <div class="col-md-8">
            <strong>Client</strong>
            <div class="font-size-14 mt-1">{{ selectedMessage.customerName || '-' }}</div>
          </div>

          <div class="col-md-4">
            <strong>Date</strong>
            <div class="font-size-14 mt-1">{{ selectedMessage.timestamp }}</div>
            <div v-if="selectedMessage.viewedTimeStamp" class="text-secondary"><i>Ouvert le {{ selectedMessage.viewedTimeStamp }}</i></div>

          </div>
          
        </div>

        <div class="row mb-3">
          <!--div class="col-md-6">
            <b-badge :variant="selectedMessage.viewedTimeStamp ? 'success' : 'danger'">
              {{ selectedMessage.viewedTimeStamp ? 'Message lu' : 'Message non lu' }}
            </b-badge>
          </div-->

          

          <!-- <div class="col-md-6 text-md-right" v-if="selectedMessage.viewedTimeStamp">
            <strong>Date d'ouverture</strong>
            <div>{{ selectedMessage.viewedTimeStamp }}</div>
          </div> -->
        </div>

         <div class="mb-3">
          <strong>Objet :</strong>
          <div class="mt-2 font-size-14">
            {{ selectedMessage.subject }}
          </div>
        </div>

        <div class="mb-3">
          <strong>Message :</strong>
          <div class="border rounded p-3 mt-2 font-size-16" style="white-space: pre-line;">
            {{ selectedMessage.content }}
          </div>
        </div>

        

      </div>
    </b-modal>


    </div>


  </Layout>
</template>

<style>
.truncate-title {
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



<style scoped>
  
    .style-vselect-big .vs__search {
      line-height: 1;
      color: #333333;
      font-size: 1em;
    }

   

    .style-vselect-big .vs__search::placeholder,
    .style-vselect-big .vs__dropdown-toggle,
    .style-vselect-big .vs__search,
    .style-vselect-big .vs__dropdown-menu {
      line-height: 1.6;
      font-size: 1em;
      background: white;
    }

    .style-vselect-big .vs__clear,
    .style-vselect-big .vs__open-indicator {
      fill: #000; /*#d90100;*/
    }
</style>